import { z } from 'zod';
import { zAddress } from './primitives.js';
/**
 * Leader analytics: how a tracked wallet (or an address being considered) has traded, computed
 * from its own swaps in `observed_swaps`. Amounts in lamports are decimal strings (may be
 * negative); times are ISO strings.
 */
export const ANALYTICS_WINDOWS = ['7d', '30d'];
export const ANALYTICS_WINDOW_DAYS = { '7d': 7, '30d': 30 };
export const zAnalyticsWindowQuery = z.object({
    window: z.enum(ANALYTICS_WINDOWS).default('7d'),
});
/** Analyse an address before tracking it (reads its recent history from the chain). */
export const zAnalyzeAddress = z.object({ address: zAddress });
//# sourceMappingURL=leader-analytics.js.map